import { Language, Links, ORDER } from './types';

const languages: Required<Language> = Object.freeze({
  'x-default': {
    langCode: '',
    order: ORDER.None,
  },
  'en-US': {
    langCode: '',
    order: ORDER.None,
  },
  'en-GB': {
    langCode: 'co.uk',
    order: ORDER.Last,
  },
  de: {
    langCode: 'de',
    order: ORDER.Last,
  },
  ru: {
    langCode: 'ru',
    order: ORDER.Skipped,
  },
  es: {
    langCode: 'es',
    order: ORDER.First,
  },
  pt: {
    langCode: 'pt',
    order: ORDER.First,
  },
  nl: {
    langCode: 'nl',
    order: ORDER.First,
  },
  fr: {
    langCode: 'fr',
    order: ORDER.First,
  },
  it: {
    langCode: 'fr',
    order: ORDER.First,
  },
  da: {
    langCode: 'da',
    order: ORDER.First,
  },
  sv: {
    langCode: 'sv',
    order: ORDER.First,
  },
  ja: {
    langCode: 'ja',
    order: ORDER.First,
  },
  ko: {
    langCode: 'ko',
    order: ORDER.First,
  },
  zh: {
    langCode: 'zh',
    order: ORDER.First,
  },
  tr: {
    langCode: 'tr',
    order: ORDER.First,
  },
  no: {
    langCode: 'no',
    order: ORDER.First,
  },
  fi: {
    langCode: 'fr',
    order: ORDER.First,
  },
});

export const LINKS: Links[] = [
  {
    lang: 'x-default',
  },
  {
    lang: 'en-US',
  },
  {
    lang: 'en-GB',
  },
  {
    lang: 'de',
  },
  {
    lang: 'ru',
  },
  {
    lang: 'es',
  },
  {
    lang: 'pt',
  },
  {
    lang: 'nl',
  },
  {
    lang: 'fr',
  },
  {
    lang: 'it',
  },
  {
    lang: 'da',
  },
  {
    lang: 'sv',
  },
  {
    lang: 'ja',
  },
  {
    lang: 'ko',
  },
  {
    lang: 'zh',
  },
  {
    lang: 'tr',
  },
  {
    lang: 'no',
  },
  {
    lang: 'fi',
  },
];

export function getLinks(domain: string, path: string): (Links | undefined)[] {
  const tempLinks = LINKS.map(({ lang }: Links): Links | undefined => {
    const language = languages[lang].langCode;
    if (languages[lang].order === ORDER.None) {
      return {
        lang,
        href: `https://www.${domain}.com${path}`,
      };
    }
    if (languages[lang].order === ORDER.First) {
      return {
        lang,
        href: `https://www.${language}.${domain}.com${path}`,
      };
    }
    if (languages[lang].order === ORDER.Last) {
      return {
        lang,
        href: `https://www.${domain}.${language}${path}`,
      };
    }
    return undefined;
  });
  return tempLinks.filter(links => links);
}
